import { OptionType } from './types';

export const option_types = Object.values(OptionType);
